import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Listuser } from '../store/slices/auth';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';

const UserList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [ListUser, setListUser] = useState([]);
  const [columns, setColumns] = useState([
    { header: 'Name', field: 'name' },
    { header: 'Email', field: 'email' },
    { header: 'Role', field: 'role' },
    { header: 'Permissions', field: 'permissions' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      actionButtons: [
        { name: 'Edit', className: 'btn-default' },
        { name: 'Delete', className: 'btn-cancel' },
      ],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');


  const fetchListUser = async () => {
    setIsLoading(true);
    try {
      const data = await dispatch(Listuser({profile_id:id})).unwrap();
      setIsLoading(false);
      console.log(data?.user?.data)
      setListUser(data?.user?.data);
    } catch (error) {
      setIsLoading(false);
      setListUser([]);
      console.log('Error fetching :', error.message);
    }
  };


  useEffect(() => {
    fetchListUser();
  }, [dispatch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    navigate(`/edit-user/${item.id ? item.id : null}`);
  };

//   const handleDelete = (item) => {
//     const confirmDelete = window.confirm('Are you sure you want to delete this invoice?');
//     if (confirmDelete) {
//       setIsLoading(true);
//       dispatch(invoicesDelete({ id: item.id }))
//         .unwrap()
//         .then(() => {
//           setIsLoading(false);
//           fetchInvoices(); // Refresh the invoice list
//         })
//         .catch(({ message }) => {
//           setIsLoading(false);
//           console.log(message);
//         });
//     }
//   };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };


  const filtereditemList = ListUser?.filter(
    (party) =>
      party?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.role?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.permissions?.toLowerCase()?.includes(searchQuery?.toLowerCase()) 
  );


  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Users</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">User</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                Users List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default" onClick={() => navigate('/add-user')}>
                Add User
              </button>
            </div>
          </div>

          {/* <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>Customer</label>
                      <Select options={partyOptions} placeholder="--Select Customer--" value={selectedParty} onChange={setSelectedParty} />
                    </div>
                    <div className="col-md-3">
                      <label>From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                      <label>To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filtereditemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filtereditemList?.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                // handleDelete={handleDelete}
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UserList;
